import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=5f5c123d&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=ts&"
export * from "./Users.vue?vue&type=script&lang=ts&"
import style0 from "./Users.vue?vue&type=style&index=0&id=5f5c123d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5c123d",
  null
  
)

export default component.exports